// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__9MsrF","summary":"CartItem_summary__mvIxj","price":"CartItem_price__O-DHp","amount":"CartItem_amount__Jzm4G","actions":"CartItem_actions__cBoGj"};